'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _chart_container = require('./chart_container.js');

var _chart_container2 = _interopRequireDefault(_chart_container);

var _daily_weekly_liquidity_chart = require('./charts/daily_weekly_liquidity_chart.js');

var _daily_weekly_liquidity_chart2 = _interopRequireDefault(_daily_weekly_liquidity_chart);

var _fund_nav_chart = require('./charts/fund_nav_chart.js');

var _fund_nav_chart2 = _interopRequireDefault(_fund_nav_chart);

var _intraday_chart = require('./charts/intraday_chart.js');

var _intraday_chart2 = _interopRequireDefault(_intraday_chart);

var _nav_chart = require('./charts/nav_chart.js');

var _nav_chart2 = _interopRequireDefault(_nav_chart);

var _net_inflow_outflow_chart = require('./charts/net_inflow_outflow_chart.js');

var _net_inflow_outflow_chart2 = _interopRequireDefault(_net_inflow_outflow_chart);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _wam_wal_chart = require('./charts/wam_wal_chart');

var _wam_wal_chart2 = _interopRequireDefault(_wam_wal_chart);

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _ramda = require('ramda');

var _collection_utility = require('common-utilities/src/collection_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getLatestDate = function getLatestDate(data) {
  return data[data.length - 1].date;
};

var renderChartContainer = function renderChartContainer(props, data, chartType, metaInfo, disclosuretext, child) {
  if (!_collection_utility.CollectionUtility.includes(props.visibleCharts, chartType) || (0, _ramda.isNil)(data) || data.length < 1) {
    return null;
  } else {
    return _react2.default.createElement(
      _chart_container2.default,
      {
        chartHeader: metaInfo.header,
        'data-testid': metaInfo.id,
        chartAsOfDate: getLatestDate(data),
        type: metaInfo.type,
        gaiaRedirectUrl: props.gaiaRedirectUrl,
        cusip: props.cusip,
        country: props.country,
        role: props.role,
        id: metaInfo.id,
        activeCardHandler: props.activeCardHandler,
        disclosureText: disclosuretext,
        breakpoint: props.breakpoint,
        placementId: metaInfo.placementId,
        disableButton: metaInfo.disableButton,
        legend: metaInfo.legend
      },
      child
    );
  }
};

var ChartParent = function (_React$Component) {
  _inherits(ChartParent, _React$Component);

  function ChartParent(props) {
    _classCallCheck(this, ChartParent);

    return _possibleConstructorReturn(this, (ChartParent.__proto__ || Object.getPrototypeOf(ChartParent)).call(this, props));
  }

  _createClass(ChartParent, [{
    key: 'dataIsNotAvailableOrChartsShouldNotRender',
    value: function dataIsNotAvailableOrChartsShouldNotRender() {
      return !this.props.historicalData || _collection_utility.CollectionUtility.size(this.props.historicalData) < 1 || !this.props.visibleCharts;
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.dataIsNotAvailableOrChartsShouldNotRender()) {
        return null;
      }
      var _props = this.props,
          historicalData = _props.historicalData,
          breakpoint = _props.breakpoint;


      (0, _jquery2.default)('.firevis-tooltip').addClass('firevisBorder');

      var filteredNavDiffData = _collection_utility.CollectionUtility.filter(historicalData.fundValuationHistoryList, function (o) {
        return !(0, _ramda.isNil)(o.constantVariableNAVDifferenceValue);
      });

      var filteredDailyWeeklyList = _collection_utility.CollectionUtility.filter(historicalData.fundValuationHistoryList, function (o) {
        return !(0, _ramda.isNil)(o.liquidityDailyPercentage) && !(0, _ramda.isNil)(o.liquidityWeeklyPercentage);
      });

      var fundValuationData = _collection_utility.CollectionUtility.filter(historicalData.fundValuationHistoryList, function (o) {
        return !(0, _ramda.isNil)(o.marketNav);
      });

      return _react2.default.createElement(
        'div',
        null,
        renderChartContainer(this.props, historicalData.historicalIntraDayNAVList, "HISTORICAL_INTRADAY_NAV", {
          header: "Share Class Market-Based NAV",
          id: "shareclass-intraday-nav-chart-container",
          placementId: "pdpCardShareClassMarketBasedNav",
          type: "mmfNav",
          disableButton: false
        }, this.props.disclosures.pdpCardShareClassMarketBasedNav, _react2.default.createElement(_intraday_chart2.default, { intradayNavData: historicalData.historicalIntraDayNAVList,
          breakpoint: this.props.breakpoint,
          shareClassInceptionDate: this.props.shareClassInceptionDate })),
        renderChartContainer(this.props, filteredNavDiffData, "CONSTANT_VARIABLE_NAV_DIFF", {
          header: _string_utility2.default.renderFormattedLabel('Difference between Constant NAV and Market-Based NAV', 'pdp-chart-constant-nav-header-label'),
          id: "diff-const-mtm-nav-chart-container",
          placementId: "pdpCardNAVDifferenceChart",
          type: "diffConstMtmNav",
          disableButton: true
        }, this.props.disclosures.pdpCardNAVDifferenceChart, _react2.default.createElement(_nav_chart2.default, { navData: filteredNavDiffData, breakpoint: this.props.breakpoint,
          shareClassInceptionDate: this.props.fundInceptionDate, navPriceFieldKey: 'constantVariableNAVDifferenceValue',
          yAxisTicks: [-25, -20, -15, -10, -5, 0, 5, 10, 15, 20, 25],
          tooltipPostfix: 'pdp-chart-bps-label',
          numberFormat: this.props.numberFormat,
          isFlatMode: this.props.isFlatMode,
          yAxisFraction: 0 })),
        renderChartContainer(this.props, historicalData.historicalNAVList, "HISTORICAL_NAV", {
          header: "Share Class Market-Based NAV",
          id: "shareclass-intraday-nav-chart-container",
          placementId: "pdpCardShareClassMarketBasedNav",
          type: "mmfNav",
          disableButton: false
        }, this.props.disclosures.pdpCardShareClassMarketBasedNav, _react2.default.createElement(_nav_chart2.default, { navData: historicalData.historicalNAVList, breakpoint: this.props.breakpoint,
          shareClassInceptionDate: this.props.shareClassInceptionDate,
          yAxisTicks: [0.9970, 0.9975, 0.9980, 0.9985, 0.9990, 0.9995, 1.000, 1.0005, 1.0010, 1.0015, 1.0020, 1.0025],
          isFlatMode: this.props.isFlatMode,
          eventAction: "share class market-based nav chart" })),
        renderChartContainer(this.props, fundValuationData, "FUND_LEVEL_NAV", {
          header: "Fund Level Market-Based NAV",
          id: "fund-nav-chart-container",
          placementId: "pdpCardFundMarketBasedNav",
          type: "fundNav",
          disableButton: false
        }, this.props.disclosures.pdpCardFundMarketBasedNav, _react2.default.createElement(_fund_nav_chart2.default, { fundValuationData: fundValuationData,
          breakpoint: this.props.breakpoint, fundInceptionDate: this.props.fundInceptionDate })),
        renderChartContainer(this.props, filteredDailyWeeklyList, "DAILY_WEEKLY_LIQUIDITY", {
          header: _string_utility2.default.renderFormattedLabel("Daily & Weekly Liquid Assets", "pdp-chart-daily-weekly-liq-asset-header"),
          id: "daily-weekly-liquidity-chart-container",
          placementId: "pdpCardDailyWeeklyLiquidAssets",
          type: "dailyWeeklyLiquidity",
          disableButton: false,
          legend: [{ label: "Weekly Liquid Assets", translationKey: "pdp-weekly-liquid-assets-label", color: "#70C4FF" }, { label: "Daily Liquid Assets", translationKey: "pdp-daily-liquid-assets-label", color: "#00A16D" }]
        }, this.props.disclosures.pdpCardDailyWeeklyLiquidAssets, _react2.default.createElement(_daily_weekly_liquidity_chart2.default, { fundValuationData: historicalData.fundValuationHistoryList,
          breakpoint: this.props.breakpoint,
          numberFormat: this.props.numberFormat,
          fundInceptionDate: this.props.fundInceptionDate,
          showBenchmarks: _collection_utility.CollectionUtility.includes(this.props.visibleCharts, 'SHOW2550BENCHMARKS') })),
        renderChartContainer(this.props, historicalData.netInflowOutflowForChartList, "NET_INFLOW_OUTFLOW", {
          header: "Net Inflows/Outflows",
          id: "net-inflow-outflow-chart-container",
          placementId: "pdpCardNetInflowsOutflows",
          type: "netInflowOutflow",
          disableButton: false
        }, this.props.disclosures.pdpCardNetInflowsOutflows, _react2.default.createElement(_net_inflow_outflow_chart2.default, { netInflowOutflowData: historicalData.netInflowOutflowForChartList,
          gaiaRedirectUrl: this.props.gaiaRedirectUrl,
          breakpoint: this.props.breakpoint })),
        renderChartContainer(this.props, historicalData.fundShareclassWamWalList, "WAM_WAL", {
          header: _string_utility2.default.renderFormattedLabel("Weighted average maturity and life in days", 'pdp-chart-wam-wal-chart-header-label'),
          id: "wam-wal-chart",
          placementId: 'pdpCardWamWalChart',
          type: "wamWal",
          disableButton: true
        }, this.props.disclosures.pdpCardWamWalChart, _react2.default.createElement(_wam_wal_chart2.default, {
          data: historicalData.fundShareclassWamWalList,
          breakpoint: breakpoint,
          numberFormat: this.props.numberFormat,
          language: this.props.language,
          country: this.props.country
        }))
      );
    }
  }]);

  return ChartParent;
}(_react2.default.Component);

exports.default = ChartParent;